/**
 * format amount to digit currency
 * @param {number} amount
 * @param {string} countryCode
 * @param {string} label
 * @returns amount with currency
 */
export const formattingDigitCurrency = (amount, countryCode, label) => {
  if (amount || amount === 0) {
    const defaultCountryCode = countryCode ? countryCode : 'fr-FR';
    const currencyName = label ? label : 'EUR';

    return new Intl.NumberFormat(defaultCountryCode, {
      style: 'currency',
      currency: currencyName,
    }).format(amount);
  }
};
